<template>
  <div v-if="value">
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="제안 내용" subtitle="UI 빌더 제안에 등록된 제안글의 내용을 불러옵니다.">
            <admin-form-item label="제목">
              {{ value.title }}
            </admin-form-item>
            <admin-form-item label="내용" style="padding-top:12px">
              {{ value.content }}
            </admin-form-item>
            <admin-form-item label="템플릿 참고 이미지/파일" style="padding-top:48px">
            <template v-for="(file, idx) in value.file">
              <a :href="file" :key="'file-'+idx" target="_blank" download>
                <img :src="file" style="border:1px solid #ddd;max-height:600px">
              </a>
            </template>
            </admin-form-item>
          </admin-box-item>
        </div>
      </div>
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="제안자 정보" subtitle="UI 빌더 제안자의 정보을 불러옵니다.">
            <admin-form-item label="이름" :isFlex="true">{{ value.service.service_user.name }}</admin-form-item>
            <admin-form-item label="이메일" :isFlex="true">{{ value.service.service_user.email }}</admin-form-item>
            <admin-form-item label="전화번호" :isFlex="true">{{ value.service.service_user.phone }}</admin-form-item>
            <admin-form-item label="서비스" :isFlex="true">{{ value.service.service_name }}({{ value.service.key }})</admin-form-item>
          </admin-box-item>
        </div>
        <div class="box">
          <admin-box-item title="런치팩 메모" subtitle="제안 진행에 관련된 메모를 기록합니다.">
            <admin-form-item label="내용">
              <admin-log-memo1 :memoLogsValue.sync="memo_logs"
                              :newMemoValue.sync="newMemo"
                              placeholder="고객 관련 간단메모를 입력하는 곳 입니다."
                              @onClickHistoryBtn="res => clickHistoryBtn(res)">
              </admin-log-memo1>
            </admin-form-item>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from "moment";
  import AdminLogMemo1 from "../../../module/common/AdminLogMemo1";

  export default {
    name: "TemplateInquiryDetail",
    components: {AdminLogMemo1},
    created() {
      this.getData();
    },
    data() {
      return {
        value: undefined,
        memo_logs: [],
        // 고객 히스토리 정보
        newMemo: '',
      }
    },
    methods: {
      getData() {
        this.$axios.get(`admin/launchpack/inquiry/template/${this.$route.query.id}`).then(res=>{
          this.value = res.data;
          this.memo_logs = res.data.memo_logs;
        })
      },
      clickHistoryBtn(res) {
        let memo = res.content;
        let msg_type = res.msg_type;
        if (memo.trim()==='') return;

        this.$axios.post('admin/launchpack/inquiry/template/' + this.$route.query.id + '/memo', {
          content: memo,
          msg_type: msg_type
        }).then(res => {
          if (res.status === 200) {
            let now = moment().format('YYYY-MM-DD HH:mm');
            let authorName = '';
            if (this.$store.getters.mode === 'admin') {
              authorName = this.$store.state.auth.admin.username;
            }
            else {
              authorName = this.$store.state.auth.partner.username;
            }
            this.memo_logs.splice(0,0,{
              created_time: now,
              author: authorName,
              content: memo,
              msg_type: msg_type
            });

            this.newMemo = '';
            //this.getData();
            this.toast('로그가 저장되었습니다.');
          }
        })
      },
    }
  }
</script>
<style lang="stylus" scoped>
</style>
